//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'OwlFakeWidget',

  data: function () {
    return {
      isAnimate: false,
    }
  },

  computed: {
    isProductPage: function() {
      const _path = this.$route.fullPath.split('/');
      return _path?.[1] === 'product' && _path?.length > 2
    }
  },

  methods: {
    startAnimate: function () {
      this.isAnimate = true;
    },
    stopAnimate: function () {
      this.isAnimate = false;
    },
    openCarrotChat: function () {
      window.carrotquest.open()
    }
  }
}
